module.exports = __webpack_public_path__ + "img/webpayLogo.c974c5e9.png";